module.exports = __webpack_public_path__ + "h5/img/touxiang.d6c321cb.png";